module.exports = __webpack_public_path__ + "static/media/reset-pass.488480cf.svg";